import BlogArticle from 'components/blog/BlogArticle';
import MainLayout from 'components/layout/MainLayout';
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import { ASSET_PREFIX } from 'utils/constants';

const CovidConcernsArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/covid-19-impact`;

  return (
    <MainLayout>
      <NextSeo
        title="A note to our DAYMADE community regarding COVID-19 | DAYMADE"
        description="A lot of you may be wondering how DAYMADE and your prizes might be affected in light of COVID-19, so we wanted to share a quick update and assure you that we will stay committed to delivering the best prizes and experiences"
        openGraph={{
          title: 'A note to our DAYMADE community regarding COVID-19 | DAYMADE',
          description:
            'A lot of you may be wondering how DAYMADE and your prizes might be affected in light of COVID-19, so we wanted to share a quick update and assure you that we will stay committed to delivering the best prizes and experiences.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/a-note-to-our-triphunters-community-regarding-covid-19',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: '',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'influncer,trips,tricks,explorer,instagram,instagrammable,awareness,competition,gifts,beach,travel,destinations,covid-19,covid,coronavirus,corona,disruption'
        // }]}
      />
      <BlogArticle imageDirectory={IMAGE_DIRECTORY} heroAltText="">
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            A note to our DAYMADE community regarding <strong>COVID-19</strong>
          </h1>

          <div className="separator" style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className="bigFirstLetter">D</span>ear DAYMADE community,
          </p>

          <p>
            First of all, we hope you're all safe and healthy, both physically
            and mentally, during these uncertain times. A lot of you may be
            wondering how DAYMADE and your prizes might be affected in light of
            COVID-19, so we wanted to share a quick update and assure you that
            we will stay committed to delivering the best prizes and experiences
            - so that you have something positive and fun to look forward to
            every week! We hope the below will address any questions you may
            have about DAYMADE, our prizes, as well as share a few exciting
            updates with you!
          </p>

          <h4>
            All trips valid for <strong>18 months</strong> and experiences valid
            for <strong>6-12 months</strong>
          </h4>

          <p>
            All trips and experiences won through DAYMADE include a lengthy
            validity period, typically at least 6 months. In fact, none of our
            prizes are tied to any specific dates, so you can easily redeem the
            prize after things settle down again. And what's better to look
            forward to than an epic trip!
          </p>

          <p>
            In the absolute worst case scenario, where travel isn't possible in
            18 months time, your holiday will be refunded to you (the value
            depends on the prize category you've won a prize in).
          </p>

          <h4>
            Fancy an experience you can enjoy at <strong>home</strong>?
          </h4>

          <p>
            For those of you who can't wait to redeem their prize, we’ve added
            some fun non-travel prizes that we think you will love. New prizes
            range from Birchbox & flower subscriptions, to online courses and
            food boxes, and more.
          </p>

          <h4>
            We’ve launched <strong>'DAYMADE Unboxed'</strong>, a new lifestyle
            raffle
          </h4>

          <p>
            With four amazing goodieboxes to choose from, we hope these prizes
            will provide some sunshine and excitement in your lives, without
            having to leave your home. Check them out {''}
            <Link href="/raffle/unboxed" style={{ margin: 0, fontWeight: 'bold' }}>
              here
            </Link>
            {''}.
          </p>

          <div className="separator" style={{ width: '50%', marginTop: 10 }} />

          <p>
            At DAYMADE, we believe life is about sharing fun experiences with
            your friends and loved ones. While we advise all our players to
            follow the advice given by the local authorities, we hope these new
            prize additions will give you more things to look forward to and be
            excited about every week. We will continue to keep a close eye on
            the situation, and update you as needed. Please stay safe and take
            care of yourselves. We very much appreciate your continued support!
          </p>

          <p>Lots of love, look after yourself ❤️</p>

          <p>
            Any questions? Just drop us a line at{' '}
            <a
              href="mailto:hello@daymade.co.uk"
              style={{ margin: 0, fontWeight: 'bold' }}
            >
              hello@daymade.co.uk
            </a>
            .<br />
            <br />
            Team DAYMADE
            <br />
            Callum, Loic, Andrew, Lisa
          </p>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default CovidConcernsArticle;
